export default __webpack_public_path__ + "static/media/IC00042-owl_eye_open.97e6760b.svg";